export default "__VITE_ASSET__BnZJ9JQd__"